import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import { ModalProps } from 'types/common';

type WarningPopupProps = ModalProps & {
    onConfirm: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    warningHeader?: string;
    warningBody?: React.ReactNode;
    discardButtonText?: string;
    confirmButtonText?: string;
    disabled?: boolean;
};

export const WarningPopUp = ({
    isOpen,
    onClose,
    warningHeader = 'Confirm Delete',
    warningBody,
    onConfirm,
    confirmButtonText = 'Confirm',
    discardButtonText = 'Cancel',
    disabled,
}: WarningPopupProps) => {
    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="xs">
            <Box px={3} pt={3}>
                <Typography variant="h5">{warningHeader}</Typography>
            </Box>
            <DialogContent>
                {warningBody || <Typography variant="body2">Are you sure you want to delete?</Typography>}
            </DialogContent>
            <DialogActions>
                <Box width="100%" display="flex" justifyContent="flex-end" m={1} gap={1.5} className="actions">
                    <Button disabled={disabled} variant="outlined" size="small" onClick={onClose}>
                        {discardButtonText}
                    </Button>
                    <Button disabled={disabled} variant="contained" size="small" onClick={onConfirm}>
                        {confirmButtonText}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};
